import React, { useEffect, useState } from "react";
import { API_ciudadanos, API_catalogos } from "../../config/apiConfig";
import { FaHouseUser, FaPenToSquare, FaCheck, FaX } from "react-icons/fa6";
import { toast } from "react-toastify";
import "../../pages/user/css/Curriculum.css";
import { API_BASE_URL } from "../../config/apiConfig";
import { useAuth } from "../../context/AuthContext";
// import { prestaciones } from "../../utils/data/prestaciones";
import { disponibilidad } from "../../utils/data/disponibilidad";

const Social = ({ usuario }) => {
  const { token } = useAuth();

  const [datosSociales, setDatosSociales] = useState({
    conciliacion: false,
    horario: [],
    prestaciones: [],
    vivienda: "",
  });

  const [editando, setEditando] = useState(false);
  const [tempDatos, setTempDatos] = useState(datosSociales);
  const [prestaciones, setPrestaciones] = useState([]);

  const normalizarTexto = (str) =>
    str
      ?.normalize("NFD")
      .replace(/\u0300-\u036f/g, "")
      .toLowerCase();

  useEffect(() => {
    const getBenefits = async () => {
      try {
        const res = await fetch(`${API_catalogos}/prestaciones`);
        const data = await res.json();
   
        setPrestaciones(
          data.map((prestacion) => prestacion.ref.toUpperCase()) || []
        );
      } catch (error) {
        console.error("❌ Error fetching prestaciones:", error);
      }
    };
    getBenefits();
  }, []);

  useEffect(() => {
    const obtenerDatosSociales = async () => {
      try {
        const res = await fetch(`${API_ciudadanos}/${usuario.userId}`);
        const data = await res.json();

        const nuevosDatos = {
          conciliacion: data.conciliacionFamiliar?.value || false,
          horario: Array.isArray(data.conciliacionFamiliar?.horario)
            ? data.conciliacionFamiliar.horario
            : data.conciliacionFamiliar?.horario
            ? [data.conciliacionFamiliar.horario]
            : [],
          prestaciones: Array.isArray(data.prestaciones)
            ? data.prestaciones.filter(element => element !== '').map((p) => normalizarTexto(p).toUpperCase())
            : [],
          vivienda: normalizarTexto(data.vivienda || ""),
        };
      
        setDatosSociales(nuevosDatos);
        setTempDatos(nuevosDatos);
      } catch (error) {
        console.error(
          "Error al obtener los datos sociales del usuario:",
          error
        );
      }
    };

    if (usuario?.userId) {
      obtenerDatosSociales();
    }
  }, [usuario]);

  const handleChange = (campo, valor) => {
    setTempDatos((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleCheckboxChange = (campo, valor) => {
    const nuevasPrestaciones = tempDatos[campo].includes(valor)
      ? tempDatos[campo].filter((element) => element !== valor)
      : [...tempDatos[campo], valor];
    setTempDatos((prev) => ({ ...prev, [campo]: nuevasPrestaciones }));
  };

  const handleGuardar = async () => {
    const body = {
      vivienda: tempDatos.vivienda,
      prestaciones: tempDatos.prestaciones,
      conciliacionFamiliar: {
        value: tempDatos.conciliacion,
        horario: tempDatos.horario,
      },
    };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al actualizar datos sociales");

      toast.success("Situación socioeconómica actualizada correctamente");
      setDatosSociales(tempDatos);
      setEditando(false);
    } catch (error) {
      console.error("❌ Error al actualizar situación social:", error);
      toast.error("Error al guardar los datos sociales");
    }
  };

  const handleCancelar = () => {
    setTempDatos(datosSociales);
    setEditando(false);
  };

  return (
    <div className="ocupaciones caja-verde">
      <div className="titulo-editar between fondo-verde">
        <h2 className="blanco fondo-verde align-center mayusculas">
          <FaHouseUser /> SITUACIÓN SOCIOECONÓMICA
        </h2>
        {!editando && (
          <button
            aria-label="Editar situació socioeconómica"
            className="fondo-verde blanco no-border"
            onClick={() => setEditando(true)}
          >
            <FaPenToSquare />
          </button>
        )}
      </div>

      <div className="contenido between">
        {/* Prestaciones */}
        <div className="column prestaciones">
          <h3 className="verde mayusculas">PRESTACIONES</h3>
          <div className="checkbox wrap">
            {prestaciones.map((p, i) => (
              <div className="align-center" key={p}>
                <input
                  type="checkbox"
                  name="prestaciones"
                  id={`${p}-${i}`}
                  value={p}
                  aria-label={p}
                  checked={tempDatos.prestaciones.includes(p.toUpperCase())}
                  disabled={!editando}
                  style={{
                    accentColor: "#28a745",
                    cursor: editando ? "pointer" : "default",
                  }}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.name, e.target.value)
                  }
                />
                <label htmlFor={`${p}-${i}`}>{p.toUpperCase()}</label>
              </div>
            ))}
          </div>
        </div>

        <hr />

        {/* Conciliación */}
        <div className="column conciliacion">
          <div className="align-center check">
            <input
              type="checkbox"
              id="conciliacion"
              checked={tempDatos.conciliacion}
              onChange={() =>
                editando &&
                handleChange("conciliacion", !tempDatos.conciliacion)
              }
            />
            <label htmlFor="conciliacion">
              <h3 className="verde mayusculas disponibilidad">
                CONCILIACIÓN FAMILIAR
              </h3>
            </label>
          </div>

          <h3 className="verde mayusculas">DISPONIBILIDAD:</h3>
          <div className="checkbox wrap">
            {disponibilidad.map((opcion, i) => (
              <div className="align-center" key={opcion}>
                <input
                  type="checkbox"
                  name="horario"
                  id={`${opcion}-${i}`}
                  value={opcion}
                  aria-label={opcion}
                  checked={tempDatos.horario.includes(opcion)}
                  disabled={!editando}
                  style={{
                    accentColor: "#28a745",
                    cursor: editando ? "pointer" : "default",
                  }}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.name, e.target.value)
                  }
                />
                <label htmlFor={`${opcion}-${i}`}>
                  {opcion.charAt(0).toUpperCase() + opcion.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </div>

        <hr />

        {/* Vivienda */}
        <div className="column vivienda">
          <h3 className="verde mayusculas">VIVIENDA</h3>
          <div className="checkbox wrap">
            {["alquilada", "propiedad", "ocupada", "compartida", "psh"].map(
              (v) => (
                <div className="align-center" key={v}>
                  <input
                    type="radio"
                    name="vivienda"
                    value={v}
                    aria-label={v}
                    checked={tempDatos.vivienda === v}
                    onClick={() => {
                      if (!editando) return;
                      handleChange(
                        "vivienda",
                        tempDatos.vivienda === v ? "" : v
                      );
                    }}
                  />
                  <label>{v.charAt(0).toUpperCase() + v.slice(1)}</label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      {editando && (
        <div className="check flex end gap-10 mr-20 mb-5">
          <button
            aria-label="Guardar cambios"
            className="fondo-blanco verde"
            onClick={handleGuardar}
          >
            <FaCheck />
          </button>
          <button
            aria-label="Cancelar cambios"
            className="fondo-blanco rojo"
            onClick={handleCancelar}
          >
            <FaX />
          </button>
        </div>
      )}
    </div>
  );
};

export default Social;
